import { Link, useParams } from "react-router-dom";
import { movies } from "@/mocks/movies";
import { newsList } from "@/mocks/news";
import MovieDetail from "@/pages/detail/components/MovieDetail";
import NewsDetail from "@/pages/detail/components/NewsDetail";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function DetailPage() {
  const { id } = useParams();
  const movie = movies.find((m) => m.id === id);
  const news = newsList.find((n) => n.id === id);

  usePageMeta("内容详情 - 蜜月TV", "蜜月TV影视与资讯详情页。");

  if (movie) return <MovieDetail movie={movie} />;
  if (news) return <NewsDetail news={news} />;

  return (
    <div className="w-full px-4 md:px-8 py-24 text-center">
      <i className="ri-file-unknow-line text-6xl text-foreground-300" />
      <h1 className="text-xl md:text-2xl font-black text-foreground-900 mt-5">
        影视内容不存在或已下架
      </h1>
      <p className="text-sm text-foreground-500 mt-3">
        你访问的内容可能已被移除，或链接有误。不妨回到首页再看看其他推荐。
      </p>
      <div className="flex items-center justify-center gap-3 mt-7">
        <Link
          to="/"
          className="px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
        >
          返回首页
        </Link>
        <Link
          to="/category/tv"
          className="px-5 py-2.5 rounded-md border border-background-200 text-sm font-semibold text-foreground-700 hover:border-primary-300 hover:text-primary-700 transition-colors whitespace-nowrap"
        >
          浏览影视
        </Link>
      </div>
    </div>
  );
}